// api/carrierAuth.js
import axios from '@/api'

/**
 * 运营商一键登录
 * @param {Object} data - 登录参数
 * @param {string} data.accessCode - 运营商认证token (后端期望 accessCode)
 * @param {string} [data.carrierType] - 运营商类型：CMCC-中国移动，CUCC-中国联通，CTCC-中国电信
 */
export const carrierLogin = (data) => {
  return axios.post('/auth/carrier/login', data)
    .then(res => res.data)
}
